import { keycloakApi } from '@/connection/keycloak-api';

class CountdownService {
  private countdownTimeInMinutes = 30;

  private countdownDate: number;

  private interval: number;

  isTimerAboutToExpire: boolean;

  clock: HTMLElement;

  start() {
    this.countdownDate = this.getCountdownDate(this.countdownTimeInMinutes);

    this.interval = window.setInterval(() => {
      const now = Date.now();
      const nowSec = Math.floor(now / 1000);
      const time = this.countdownDate - nowSec;

      const minute = 60;
      const hour = minute * 60;
      const day = hour * 24;

      const hours = Math.floor((time % day) / hour);
      const minutes = Math.floor((time % hour) / minute);
      const seconds = time % minute;

      this.getFormattedTime(hours, minutes, seconds);
      this.timerIsAboutToExpire(minutes);
      this.logoutOnTimerExpired(time);
    }, 1000);
  }

  stopInterval() {
    window.clearInterval(this.interval);
  }

  reset() {
    window.clearInterval(this.interval);
    this.start();
  }

  timerIsAboutToExpire(minutes: number) {
    if (minutes < 2) {
      this.isTimerAboutToExpire = true;
    }
  }

  logoutOnTimerExpired(time: number) {
    if (time <= 0) {
      this.stopInterval();
      keycloakApi.clearStorageAndLogout();
    }
  }

  getCountdownDate(value: number) {
    const timeInMinutes = value;
    const currentTime = Date.now();
    return Math.floor(new Date(currentTime + timeInMinutes * 60 * 1000).getTime() / 1000);
  }

  getFormattedTime(hours: number, minutes: number, seconds: number) {
    this.clock = document.getElementById('clock');
    const clockStrArr: string[] = [
      this.formatTimeUnit(hours),
      this.formatTimeUnit(minutes),
      this.formatTimeUnit(seconds),
    ];

    // Die formatierte Zeit wird erst dann angezeigt, wenn das HTMLElement gerendert wurde (nicht null ist)
    if (this.clock?.innerText !== undefined) {
      this.clock.innerHTML = clockStrArr.join(':');
    }
  }

  formatTimeUnit(value: number) {
    return `0${value}`.slice(-2);
  }
}

export const countdownService = new CountdownService();
